// set after cookie preferences are (re)saved, used to force a reload for users affected by the stale-language-cookie bug
export const COOKIES_RESET_FOR_EXISTING_USERS_COOKIE_NAME = "cookies-reset-for-existing-users";
